import Grid from "@mui/material/Grid2";
import { FormGroup, Input } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import QuantityUnitSelect from "../select/QuantityUnitSelect";
import { Fragment, ReactNode } from "react";
import { QuantityUnit } from "__generated__/graphql";
import NumberInput from "components/cck/NumberInput";
import FormField from "components/cck/FormField";
import { CalculationMethodFormByTypeProps } from "@schemas/calculationmethods/schema";

type FormValues = {
	agreements: {
		calculationMethod: {
			quantityUnit?: QuantityUnit;
			price?: number;
			customUnit?: string;
		}
	}[];
};

type FormField = {
	id: string;
	render: () => ReactNode;
}

const QuantityUnitCalculationMethodForm = ({ index, currency, hiddenFields }: CalculationMethodFormByTypeProps) => {
	const { control, formState: { errors } } = useFormContext<FormValues>();

	const quantityUnit = useWatch({ control, name: `agreements.${index}.calculationMethod.quantityUnit` });

	const QuantityUnitCalculationMethodFormFields: FormField[] = [
		{
			id: "calculationMethod.quantityUnit",
			render: () => (
				<Grid size={4}>
					<FormField errors={errors} name={`agreements.${index}.calculationMethod.quantityUnit`}>
						<FormGroup label={intl.formatMessage({ id: "QUANTITY_UNIT" })} required>
							<Controller
								rules={{ required: true }}
								control={control}
								render={({ field }) => (
									<QuantityUnitSelect {...field} />
								)}
								name={`agreements.${index}.calculationMethod.quantityUnit`} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
		{
			id: "calculationMethod.price",
			render: () => quantityUnit && (
				<Grid size={4}>
					<FormField errors={errors} name={`agreements.${index}.calculationMethod.price`}>
						<FormGroup label={intl.formatMessage({ id: `PRICE_PER_${quantityUnit}` })} overflow="hidden" required>
							<Controller
								name={`agreements.${index}.calculationMethod.price`}
								control={control}
								rules={{ required: true }}
								render={({ field }) => (
									<NumberInput
										{...field}
										addonBefore={currency.symbol} />
								)} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
		{
			id: "calculationMethod.customUnit",
			render: () => quantityUnit === QuantityUnit.Custom && (
				<Grid size={4}>
					<FormField errors={errors} name={`agreements.${index}.calculationMethod.customUnit`}>
						<FormGroup label={intl.formatMessage({ id: "CONTRACT_UNIT" })} overflow="hidden">
							<Controller
								name={`agreements.${index}.calculationMethod.customUnit`}
								control={control}
								render={({ field }) => (
									<Input
										{...field} />
								)} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
	];

	return (
		<>
			{QuantityUnitCalculationMethodFormFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}

		</>
	);
};

export default QuantityUnitCalculationMethodForm;
